import moment from "moment";
import React from "react";
import { useChatMessageStore } from "../store";
import "../style.scss";

export default function ChatTabItem({
                                      lastMessage,
                                      userProfile,
                                      updateSeenMutation,
                                    }) {
  const sender = lastMessage.sender;
  const receiver = lastMessage.receiver;

  const otherPerson = sender.id !== userProfile.id ? sender : receiver;
  const otherPersonName = `${otherPerson.firstName} ${otherPerson.lastName}`;
  const hasSeen = lastMessage.seen.some(userId => userId === userProfile.id);
  const chatMessageStore = useChatMessageStore();

  const isTyping = chatMessageStore.chatTabItemIds.includes(otherPerson.id);

  return (
    <div
      key={`chatmessage-${lastMessage.id}`}
      style={{
        backgroundColor: !hasSeen ? "#93c5fd" : "unset",
        padding: "0 16px",
        paddingTop: "12px",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "1rem",
          cursor: "pointer",
          borderBottom: "1px solid rgba(219, 219, 219)",
          paddingBottom: "10px",
        }}
        onClick={(event) => {
          event.stopPropagation();

          if (!hasSeen) {
            updateSeenMutation.mutate({ receiverId: otherPerson.id });
          }

          chatMessageStore.setChatMessageWindows({
            img: otherPerson.img,
            name: otherPersonName,
            id: otherPerson.id,
            titleProfessions: otherPerson.titleProfessions,
            isTyping: false,
            type: "individual",
          });
        }}
      >
        <div style={{ position: "relative", display: "inline-block", height: "100%", margin: "auto" }}>
          <img
            src={otherPerson.img}
            alt={otherPerson.name}
            style={{
              width: "3rem",
              borderRadius: "9999px",
            }}
          />
          {chatMessageStore.onlineUsers.some(user => user.userId === otherPerson.id) && (
            <div
              style={{
                position: "absolute",
                bottom: "0",
                right: "0",
                width: "0.8rem",
                height: "0.8rem",
                backgroundColor: "green",
                borderRadius: "50%",
                border: "2px solid white", // Add a white border for better visibility
              }}
            />
          )}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <span style={{ fontWeight: "bold" }}>{otherPersonName}</span>
            <div style={{ position: "relative" }}>
              <span
              >
                {moment(lastMessage.createdAt).format("MMMM D")}
              </span>
              {!hasSeen && (
                <div
                  style={{
                    top: 0,
                    position: "absolute",
                    bottom: "0",
                    right: "-12px",
                    width: "0.8rem",
                    height: "0.8rem",
                    backgroundColor: "red",
                    borderRadius: "50%",
                    border: "2px solid white", // Add a white border for better visibility
                  }}
                />
              )}
            </div>
          </div>
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "200px",
            }}
          >
            {isTyping ? (
              <span className="loading">typing</span>
            ) : (
              <>
                {sender.id === userProfile.id ? (
                  <>
                  {`You: ${lastMessage.content}`}
                  </>
                ) : (
                  <>
                    {lastMessage.isInvitation ? (
                      <>{`${sender.firstName} has invited you to chat.`}</>
                    ): (
                      <>{`${sender.firstName}: ${lastMessage.content}`}</>
                    )}
                  </>
                )}
              </>
            )}
            </span>
        </div>
      </div>
    </div>
  );
}